import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-card-content',
  templateUrl: './av-card-content.component.html',
  styleUrls: ['./av-card-content.component.scss']
})
export class AvCardContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
